/*
    MENU
*/

window.payloads = {
    "payloads": []
};

// Select aligment
window.selectAligmentMenu = function(pos) {
    var leftAlignmentContainer = document.getElementsByClassName('menu-alignment-element-left')[0];
    var centerAlignmentContainer = document.getElementsByClassName('menu-alignment-element-center')[0];
    var rightAlignmentContainer = document.getElementsByClassName('menu-alignment-element-right')[0];
    if (pos == 'left') {
        leftAlignmentContainer.classList.add('selected');
        centerAlignmentContainer.classList.remove('selected');
        rightAlignmentContainer.classList.remove('selected');
        window.customStyle['.container-payloads']['text-align'] = "left !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else if (pos == 'center') {
        leftAlignmentContainer.classList.remove('selected');
        centerAlignmentContainer.classList.add('selected');
        rightAlignmentContainer.classList.remove('selected');
        window.customStyle['.container-payloads']['text-align'] = "center !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else if (pos == 'right') {
        leftAlignmentContainer.classList.remove('selected');
        centerAlignmentContainer.classList.remove('selected');
        rightAlignmentContainer.classList.add('selected');
        window.customStyle['.container-payloads']['text-align'] = "right !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    }
}

// Background color
var select = document.getElementById('menu-background-color-selector');
var colorPreview = document.getElementById('color-preview-menu-background');
window.updateColorMenuBackground = function() {
    select.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Color";
    select.appendChild(option);

    colorPreview.style.backgroundColor = "transparent";
    colorPreview.style.border = "#5D5D5D 1px solid";
    
    for (const val of window.colors.colors) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        select.appendChild(option);
    }
}
select.addEventListener('change', function(event) {
    let index = 0;
    for (const val of window.colors.colors) {
        if (val.settings.name == event.target.value) {

            idSelected = index;

            colorPreview.style.backgroundColor = val.settings.color;
            window.customStyle['.container-payloads']['background-color'] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
        index++;
    }

    if (event.target.value == "") {
        colorPreview.style.backgroundColor = "transparent";
        colorPreview.style.border = "#5D5D5D 1px solid";
        window.customStyle['.container-payloads']['background-color'] = "transparent !important";
        window.styleElement.textContent = window.css.of(window.customStyle);
    } else {
        colorPreview.style.border = "transparent";
    }

})

// Font Style
var selectFont = document.getElementById("menu-font");
window.updateMenuFonts = function() {
    selectFont.replaceChildren();

    var option = document.createElement('option');
    option.value = "";
    option.text = "No Fonts";
    selectFont.appendChild(option);

    for (const val of window.fonts.fonts) {
        var option = document.createElement('option');
        option.value = val.settings.name;
        option.text = val.settings.name;
        option.setAttribute("data-id", val.id);
        selectFont.appendChild(option);
    }
}
selectFont.addEventListener("change", function(event) {
    for (const val of window.fonts.fonts) {
        if (val.settings.name == event.target.value) {
            selectFont.style.color = val.settings.color;
            selectFont.style.fontFamily = val.settings.fontFamily;
            selectFont.style.fontSize = val.settings.size;

            window.customStyle["#payloads-headline"]["font-family"] = val.settings.fontFamily + " !important";
            window.customStyle["#payloads-headline"]["font-size"] = val.settings.size + " !important";
            window.customStyle["#payloads-headline"]["color"] = val.settings.color + " !important";
            window.styleElement.textContent = window.css.of(window.customStyle);
        }
    }
});

// Change Headline
var headlineMenu = document.getElementById("menu-headline");
headlineMenu.addEventListener("change", function(event){
    document.getElementById("payloads-headline").innerHTML = event.target.value;
    window.customJSON["menu"]["headline"] = event.target.value;
    console.log(window.customJSON);
})

// Add Payload
var id = 0;
var addPayload = document.getElementById("add-menu-payloads");
addPayload.addEventListener("click", function(event){
    var payloadContainer = document.getElementById("menu-payloads-container");

    var newPayload = document.createElement("div");
    newPayload.classList.add("payload-settings","settings-sub-block-content-line");
    newPayload.setAttribute("data-id", id);

    var newPayloadName = document.createElement("input");
    newPayloadName.setAttribute("type", "text");
    newPayloadName.setAttribute("placeholder", "Payload...");
    newPayloadName.setAttribute("data-id", id);
    newPayloadName.addEventListener("change", function(event) {
        var element = this;
        var idElement = element.getAttribute("data-id");

        var payloadExists = false;

        window.payloads.payloads.forEach(function(obj, i){
            if (obj.payload == event.target.value) {
                payloadExists = true;
            }
        });
        
        if (!payloadExists) {
            window.payloads.payloads.forEach(function(obj, i){
                if (idElement == obj.id) {
                    obj.payload = event.target.value;
                }
            });
        } else {
            alert("You can not repeat the name of the color.");
        }
        updatePayloads();
    })

    // Payload Remove
    var newPayloadRemove = document.createElement("div");
    newPayloadRemove.classList.add("remove-payload");
    newPayloadRemove.addEventListener('click', function(){
        var element = this;

        var idElement = element.parentNode.getAttribute("data-id");

        window.payloads.payloads.forEach(function(obj, i){

            if (idElement == obj.id) {
                window.payloads.payloads.splice(i, 1);
            }
        })
        element.parentNode.remove();

        updatePayloads();
    })
    var newRemovePayloadLogo = document.createElement("div");
    newRemovePayloadLogo.classList.add("remove-payload-logo");

    newPayload.append(newPayloadName);
    newPayloadRemove.append(newRemovePayloadLogo);
    newPayload.append(newPayloadRemove);

    payloadContainer.append(newPayload);

    var newPayloadJSON = {
        "id": id,
        "payload": "Lorem Ipsum..."
    };

    window.payloads['payloads'].push(newPayloadJSON);

    updatePayloads();
    id++;
})


// Update Payloads
function updatePayloads() {
    console.log("update payloads");
    var payloads = document.getElementById("payloads");
    payloads.replaceChildren();
    window.customJSON["menu"]["payloads"] = [];

    window.payloads.payloads.forEach(function(obj, i){
        var button = document.createElement("button");
        button.classList.add("MessengerQuickReply");
        button.innerHTML = obj.payload;
        payloads.append(button);

        window.customJSON["menu"]["payloads"].push(obj.payload);
    })
}